import { message, Select } from "antd";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { postInviteFacilityUser } from "../../../helpers/api";
import { getUser } from "../../../helpers/auth";
import { hasPermission } from "../../../helpers/utilities";
import { action, resouces } from "../../../helpers/auth";

const { Option } = Select;

const InviteFacilityUserForm = ({ onSuccess, onClose }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();
  const [role, setRole] = useState("nurse");

  const { mutateAsync: inviteUser, isLoading } = useMutation(
    (data) => postInviteFacilityUser(data),
    {
      onSuccess: (data) => {
        if (data.status === 201) {
          message.success(data.data?.message || "Invitation sent successfully");
          reset();
          setRole("nurse");
          onSuccess?.();
          onClose?.();
        } else {
          throw data;
        }
      },
      onError: (error) => {
        const errMsg =
          error?.response?.data?.message || "Failed to send invitation";
        message.error(errMsg);
      },
    }
  );

  const onSubmit = async (data) => {
    if (!hasPermission(resouces.users, action.canCreate)) {
      message.error("Permission denied");
      return;
    }

    const userRole = getUser()?.role?.toLowerCase();
    if (userRole !== "admin" && userRole !== "superuser") {
      message.error("Only administrators can invite users");
      return;
    }

    await inviteUser({
      email: data.email,
      role: role,
      facilityId: getUser().facility.id,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="field col-12">
        <label className="mb-0" htmlFor="email">
          Email Address
        </label>
        <input
          className="input"
          autoFocus
          type="email"
          {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          })}
          id="email"
          placeholder="user@example.com"
        />
        {errors.email && (
          <small className="text-danger">{errors.email.message}</small>
        )}
        <small>Invitation will be sent to this email address</small>
      </div>

      <div className="field col-12 mt-3">
        <label className="mb-0" htmlFor="role">
          Role
        </label>
        <Select
          value={role}
          onChange={(v) => setRole(v)}
          size="large"
          id="role"
          className="d-block"
          placeholder="select role">
          {hasPermission(resouces.admin, action.canCreate) && (
            <Option value="admin" key="admin">
              Admin
            </Option>
          )}
          <Option value="doctor" key="doctor">
            Medical Doctor
          </Option>
          <Option value="nurse" key="nurse">
            Nurse
          </Option>
          <Option value="frontdesk" key="frontdesk">
            Front Desk
          </Option>
          <Option value="partner" key="partner">
            Partner
          </Option>
        </Select>
        <small>Role assigned to the user in this facility</small>
      </div>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <button
          type="button"
          className="button app-btn"
          onClick={onClose}
          disabled={isLoading}>
          Cancel
        </button>
        <button
          type="submit"
          className={`button app-btn btn-prim ${isLoading && "is-loading"}`}>
          Send Invitation
        </button>
      </div>
    </form>
  );
};

export default InviteFacilityUserForm;
